import * as yup from "yup";

export const domainFormValidation = yup.object().shape({
  domain: yup
    .string()
    .max(100)
    .matches(
      /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.\_]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
      "Richtige Url eingeben"
    )
    .required("Dieses Feld ist notwendig"),
  verified_logistics_flag: yup.boolean(),
  verified_service_flag: yup.boolean(),
  country_id: yup
    .object()
    .shape({
      id: yup.number(),
      short_name: yup.string(),
    })
    .required("Dieses Feld ist notwendig")
    .nullable(),
});
